
import { Component, Vue, Prop, Ref } from 'vue-property-decorator'
import ImageBase from '@/components/atoms/ImageBase.vue'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import FloatPanel, { POSITION_SET } from '@/components/molecules/FloatPanel.vue'
import PanelFrame from '@/components/molecules/PanelFrame.vue'

/**
 * 塾編集フロートメニュー
 */
@Component({
  components: {
    ImageBase,
    ButtonBase,
    FloatPanel,
    PanelFrame,
  },
})
export default class MenuEditAcademy extends Vue {
  /** フロートメニュー部 */
  @Ref()
  floatPanel!: FloatPanel

  /** 削除ボタン押下時のイベント */
  @Prop()
  private eventClickDeleteButton!: (academyId: number) => void

  /** 塾情報編集ボタン押下時のイベント */
  @Prop()
  private eventClickEditAcademyButton!: (academyId: number) => void

  /** 操作対象の塾ID */
  private academyId = 0

  /** クローズ時の処理 */
  private eventClosed: (() => void) | undefined = undefined

  /**
   * 表示
   *
   * @param target 表示位置の基準にするDOM要素
   * @param academyId 操作対象塾ID
   * @param parentElement オプション情報表示エリアの基準となる親DOM要素
   */
  public async show(target: HTMLElement, academyId: number, parentElement?: HTMLElement): Promise<void> {
    this.academyId = academyId
    await this.floatPanel.show(target, POSITION_SET.LEFT_DOWN, parentElement)
  }

  /**
   * 削除ボタン押下時処理
   */
  private eventDelete(): void {
    this.floatPanel.close()
    this.eventClickDeleteButton(this.academyId)
  }

  /**
   * 編集ボタン押下時処理
   */
  private eventEditAcademy(): void {
    this.floatPanel.close()
    this.eventClickEditAcademyButton(this.academyId)
  }

  /**
   * クローズ時処理
   */
  private closeEvent(): void {
    // 設定されている場合のみ実行
    if (this.eventClosed) {
      this.eventClosed()
    }
  }
}
